import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { CreateEventForm } from '../types';
import { DateTimeService } from '../../../services/date-time.service';

@Component({
  selector: 'app-event-management-registration-details',
  templateUrl: './event-management-registration-details.component.html',
  styleUrls: ['./event-management-registration-details.component.scss'],
})
export class EventManagementRegistrationDetailsComponent {
  @Input() innerForm: FormGroup<CreateEventForm>;

  get minEventRegistrationFinishDate(): NgbDateStruct {
    let eventStartDate: string | Date =
      this.innerForm.controls.event_registration_start_date.getRawValue();

    if (!eventStartDate) {
      eventStartDate = new Date();
    }

    return DateTimeService.dateToNgbDateStruct(
      DateTimeService.adjustDateForTimezone(eventStartDate)
    );
  }
}
